import React from 'react';

const iconBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '28px',
  height: '28px',
  border: 'none',
  borderRadius: '6px',
  background: 'transparent',
  cursor: 'pointer',
  padding: 0,
};

const IconButton = ({ title, onClick, children, color, disabled }) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    onClick={onClick}
    disabled={disabled}
    style={{
      ...iconBtnStyle,
      color: disabled ? '#cbd5e1' : color,
      cursor: disabled ? 'default' : 'pointer',
    }}
  >
    {children}
  </button>
);

const getGonderimIcon = (sms) => {
  if (sms?.netgsmDetay?.devMode) {
    return { icon: 'fa-code', color: '#6366f1', title: 'Developer modu — gönderilmedi' };
  }
  const durum = sms?.durum;
  if (durum === 'gonderildi') {
    return { icon: 'fa-check', color: '#059669', title: 'Gönderildi' };
  }
  if (durum === 'hata') {
    return { icon: 'fa-times', color: '#dc2626', title: 'Gönderim hatası' };
  }
  return { icon: 'fa-minus', color: '#94a3b8', title: durum || 'Bilinmiyor' };
};

const getTeslimIcon = (durum, teslimDurumu) => {
  if (durum !== 'gonderildi') {
    return null;
  }
  if (teslimDurumu === 'beklemede') {
    return { icon: 'fa-clock', color: '#d97706', title: 'Teslim bekleniyor' };
  }
  if (teslimDurumu === 'iletildi') {
    return { icon: 'fa-check-double', color: '#059669', title: 'Teslim edildi' };
  }
  if (teslimDurumu === 'iletilemedi') {
    return { icon: 'fa-exclamation-triangle', color: '#dc2626', title: 'Teslim edilemedi' };
  }
  return { icon: 'fa-minus', color: '#94a3b8', title: 'Teslim bilinmiyor' };
};

/**
 * SMS gönderim + teslim durumu ikonları ve NetGSM detay butonu.
 */
const SmsDurumIkonlari = ({ sms, onInfoClick, onRefreshClick, refreshing }) => {
  const gonderim = getGonderimIcon(sms);
  const teslim = sms?.netgsmDetay?.devMode ? null : getTeslimIcon(sms?.durum, sms?.teslimDurumu);
  const hasNetgsm = !!(sms?.netgsmJobId || sms?.hariciSmsId || sms?.netgsmDetay);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
      <IconButton title={gonderim.title} color={gonderim.color}>
        <i className={`fas ${gonderim.icon}`} style={{ fontSize: '14px' }} aria-hidden />
      </IconButton>

      {teslim && (
        <IconButton title={teslim.title} color={teslim.color}>
          <i className={`fas ${teslim.icon}`} style={{ fontSize: '14px' }} aria-hidden />
        </IconButton>
      )}

      <IconButton
        title="NetGSM detayı"
        onClick={() => onInfoClick?.(sms)}
        color="#2563eb"
      >
        <i className="fas fa-info-circle" style={{ fontSize: '14px' }} aria-hidden />
      </IconButton>

      {onRefreshClick && sms?.durum === 'gonderildi' && hasNetgsm && (
        <IconButton
          title="Teslim durumunu yenile"
          onClick={() => onRefreshClick(sms)}
          color="#64748b"
          disabled={refreshing}
        >
          <i
            className={`fas fa-sync-alt${refreshing ? ' fa-spin' : ''}`}
            style={{ fontSize: '13px' }}
            aria-hidden
          />
        </IconButton>
      )}

      {sms?.hataMesaji && !sms?.netgsmDetay?.devMode && (
        <span
          title={sms.hataMesaji}
          style={{ fontSize: '11px', color: '#991b1b', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {sms.hataMesaji}
        </span>
      )}
    </div>
  );
};

export default SmsDurumIkonlari;
